import { BILLING_API_URL, SITE } from "./auth";

export const PLAN_LIMITS = {};

export function normalizePlanKey(value) {
  const key = String(value || "").trim().toLowerCase();

  if (["gold", "master", "master author", "master_author", "master-author"].includes(key)) {
    return "master author";
  }

  if (["silver", "author"].includes(key)) {
    return "author";
  }

  if (["draft", "draft", "free", "draft plan"].includes(key)) {
    return "draft";
  }

  return key || "draft";
}

export function getPaidPlanName(userPlan) {
  const fbPlan = localStorage.getItem("fb_plan");

  const normalizedUserPlan = normalizePlanKey(userPlan?.name || userPlan);
  const normalizedFbPlan = normalizePlanKey(fbPlan);

  if (normalizedUserPlan && normalizedUserPlan !== "draft") {
    return normalizedUserPlan;
  }

  if (normalizedFbPlan && normalizedFbPlan !== "draft") {
    return normalizedFbPlan;
  }

  return normalizedUserPlan || normalizedFbPlan || "draft";
}

export async function loadPlanLimits() {
  const res = await fetch(`${BILLING_API_URL}/plans/?site=${SITE}`);
  const data = await res.json();
  
  const plans = Array.isArray(data) ? data : Array.isArray(data?.plans) ? data.plans : [];

  plans.forEach((p) => {
    const normalizedName = normalizePlanKey(p.name || p.key || p.display_name);

    const limits = {
      subplots: p.max_subplots,
      characters: p.max_characters,
      timelineEvents: p.max_timeline,
      price: p.price,
      interval: p.interval,
      arcs: p.max_character_arc,
      relationships: p.max_character_relation,
    };

    PLAN_LIMITS[normalizedName] = limits;

    if (p.name) {
      PLAN_LIMITS[normalizePlanKey(p.name)] = limits;
      PLAN_LIMITS[String(p.name).trim().toLowerCase()] = limits;
    }

    if (p.key) {
      PLAN_LIMITS[normalizePlanKey(p.key)] = limits;
      PLAN_LIMITS[String(p.key).trim().toLowerCase()] = limits;
    }

    if (p.display_name) {
      PLAN_LIMITS[normalizePlanKey(p.display_name)] = limits;
      PLAN_LIMITS[String(p.display_name).trim().toLowerCase()] = limits;
    }
  });
}

export function getPlanLimits(planName) {
  const normalizedName = normalizePlanKey(planName);

  return (
    PLAN_LIMITS[normalizedName] ||
    PLAN_LIMITS[String(planName || "").trim().toLowerCase()] ||
    null
  );
}

export default async function checkBookAccess(bookId, userId) {
  const res = await fetch(`${BILLING_API_URL}/user/book/${bookId}/access/?user_id=${userId}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access")}`,
    },
  });

  return await res.json();
}